<template>
    <div :class="['receive-result-container', succeedType !== 0 || failedType !== 0 ? 'actived' : 'deactived']">
        <div class="succeed-status-container" v-if="succeedType !== 0 && failedType === 0">
            <div class="succeed-type-1" v-show="succeedType === 1">
                <img class="icon-succeed" src="./img/succeed.png" alt="icon-succeed" />
                <p class="description">恭喜{{ studentName }}宝贝</p>
                <h1 class="title">成功领取VIPKID数学精品体验课程</h1>
                <p class="tip">请您保持电话畅通<br />孩子的班主任会给您通电哦</p>
                <p class="concat">客服电话：<a class="strong" href="tel:95056953">95056953</a></p>
            </div>
            <div class="succeed-type-2" v-show="succeedType === 2">
                <h1 class="title">感谢参与</h1>
                <p class="description">抱歉，该活动仅针对于新用户</p>
                <p class="tip">您已成功领取VIPKID数学思维体验课了，<br />请推荐给其他小伙伴吧～</p>
                <p class="concat">客服电话：<a class="strong" href="tel:95056953">95056953</a></p>
            </div>
        </div>
        <div class="failed-status-container" v-if="succeedType === 0 && failedType !== 0">
            <img class="icon-failed" src="./img/failed.png" alt="icon-failed" />

            <div class="block" v-show="failedType === 1">
                <p class="message">非常抱歉，由于系统原因<br />下单失败</p>
                <p class="tip">请与客服联系：<a class="strong" href="tel:95056953">95056953</a></p>
            </div>

            <div class="block" v-show="failedType === 2">
                <p class="message">不好意思，本活动链接已失效</p>
                <p class="tip">
                    报名VIPKID数学精品体验课<br />
                    请与客服联系：<a class="strong" href="tel:95056953">95056953</a>
                </p>
            </div>

            <div class="block" v-show="failedType === 3">
                <p class="message">非常抱歉，由于课程时间冲突<br />导致下单失败。</p>
                <p class="tip">
                    如需调整体验时间<br />
                    您可拨打客服电话：<a class="strong" href="tel:95056953">95056953</a>
                </p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.receive-result-container {
    text-align: center;
    z-index: 999;
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;

    .strong {
        color: #ff6422;
        font-weight: bold;
    }
}
.receive-result-container.actived {
    background: #fff;
}
.receive-result-container.deactived {
    pointer-events: none;
}

.icon-succeed,
.icon-failed {
    margin-top: 200px;
    width: 96px;
    height: 96px;
}

.succeed-status-container {
    .succeed-type-1 {
        .description {
            margin-top: 48px;
            font-size: 24px;
        }
        .title {
            font-size: 32px;
            margin-top: 16px;
            font-weight: bolder;
        }

        .tip {
            margin-top: 180px;
            font-size: 24px;
            line-height: 32px;
        }

        .concat {
            margin-top: 8px;
            font-size: 24px;
        }
    }
    .succeed-type-2 {
        .title {
            margin-top: 200px;
            font-size: 60px;
            font-weight: bolder;
        }

        .description {
            font-size: 24px;
            margin-top: 16px;
        }

        .tip {
            font-size: 32px;
            line-height: 48px;
            margin-top: 64px;
        }

        .concat {
            margin-top: 200px;
        }
    }
}

.failed-status-container {
    .block {
        .message {
            margin-top: 48px;
            font-weight: bolder;
            font-size: 32px;
            line-height: 40px;
        }
        .tip {
            margin-top: 48px;
            line-height: 40px;
        }
    }
}
</style>

<script>
export default {
    props: {
        /** 成功类型：0 - 无（保留）；1 - 正常成功；2 - 非新用户成功； */
        succeedType: {
            type: Number,
            default: 0
        },
        /** 错误类型：0 - 无错误；1 - 统一错误；2 - 活动失效；3 - 课程时间冲突 */
        failedType: {
            type: Number,
            default: 0
        },
        studentName: String,
        classFirstTime: String
    }
}
</script>
